// Constants
import { DEGREES, EARTH_RADIUS_METERS, KILOMETERS_PER_DEGREE } from "@/Settings/Constants/AdministrationTools/AdministrationTools";

// Types
import { IGeoPoint, IXYPoint, IAdministrationTools } from "@/Settings/types/administrationTools/model";
import { QueryClient } from "@tanstack/react-query";
function convertLatLonToXY(latitude: number, longitude: number): IXYPoint {
	const x = EARTH_RADIUS_METERS * ((longitude * Math.PI) / DEGREES["180"]);
	const y = EARTH_RADIUS_METERS * Math.log(Math.tan(Math.PI / 4 + (latitude * Math.PI) / DEGREES["360"]));

	return { x, y };
}

// Pythagorean theorem to calculate distance between two points
function distanceBetweenTwoPoints({ coordinateA, coordinateB }: { coordinateA: IGeoPoint; coordinateB: IGeoPoint }): number {
	const X = (coordinateB.lng - coordinateA.lng) * KILOMETERS_PER_DEGREE * Math.cos(coordinateA.lat);
	const Y = (coordinateB.lat - coordinateA.lat) * KILOMETERS_PER_DEGREE;
	return Math.sqrt(X * X + Y * Y);
}

function getCenterPolygon(figure: IGeoPoint[]) {
	const minMaxLat = {
		max: Math.max(...figure.map((p) => p.lat)),
		min: Math.min(...figure.map((p) => p.lat)),
	};

	const minMaxLng = {
		max: Math.max(...figure.map((p) => p.lng)),
		min: Math.min(...figure.map((p) => p.lng)),
	};

	return {
		lat: (minMaxLat.max + minMaxLat.min) / 2,
		lng: (minMaxLng.max + minMaxLng.min) / 2,
	};
}

function calculatePositionTooltip(point: IXYPoint, canvasSize: { width?: number; height?: number }) {
	const { width = 1, height = 1 } = canvasSize;
	return {
		left: `calc(${(point.x / width) * 100}% - 4px)`,
		top: `calc(${(point.y / height) * 100}% - 4px)`,
	};
}

function updateGpsLotsCache(locationId: string, queryClient: QueryClient, variables: { location: string; lotId: string }) {
	queryClient.setQueryData(["administrationTools", locationId], (cachedData: IAdministrationTools | undefined) => {
		if (!cachedData) {
			return cachedData;
		}
		const prevLots = cachedData.integrations?.globalPositioningService?.lots ?? [];
		return {
			...cachedData,
			integrations: {
				...cachedData.integrations,
				globalPositioningService: {
					...cachedData.integrations?.globalPositioningService,
					lots: prevLots.filter((lot) => lot._id !== variables.lotId),
				},
			},
		};
	});
}

export { updateGpsLotsCache, convertLatLonToXY, distanceBetweenTwoPoints, getCenterPolygon, calculatePositionTooltip };
